module.exports = __webpack_public_path__ + "static/media/ArrowRight.332d3d87.svg";